import { thumbnailMediumBlue } from '@utils/thumbnails'
import { size } from '@styles/theme'
import styled from '@emotion/styled'

import ProfileNavigateAvatar from '@elements/ProfileNavigateAvatar'
import { PostRepostIcon } from './PostRepostIcon'

const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-right: ${size(0.75)};
`

const PostLeftPanel = ({ user, isAvatar, isRepost }) => {
  return (
    <LeftPanel>
      <PostRepostIcon isRepost={isRepost} />
      <ProfileNavigateAvatar
        uuid={user?.uuid}
        src={thumbnailMediumBlue(user?.socialMedia?.thumbnail, user?.defaultAvatar)}
        canNavigate={!!user?.uuid}
        toNearby={false}
        style={{
          height: size(5),
          width: size(5),
          background: !user?.uuid && '#141414',
          color: !user?.uuid && '#333333',
          filter: isAvatar && 'grayscale(100%) contrast(120%)',
        }}
      />
    </LeftPanel>   
  )
}

export { PostLeftPanel }
